export enum RouteName {
  NotFound = '*',
  Home = '/',
  About = 'about',
  Contact = 'contact',
  Experience = 'experience',
}

export const assetsPath = 'static';

export const PHONE_NUMBER = '+1 636 699-7344';
export const EMAIL_ADDRESS = 'dev@jacob-alspaw.com';
export const LOCATION = 'Littleton, Colorado 80128';

export enum Link {
  LinkedIn = 'https://www.linkedin.com/in/jacob-alspaw',
  GitHub = 'https://github.com/jaa134',
  REPOS = 'https://github.com/jaa134?tab=repositories',
  Facebook = 'https://www.facebook.com/jacobalexander.alspaw',
  Instagram = 'https://www.instagram.com/jacobalspaw/',
  Twitter = 'https://twitter.com/JacobAlspaw',
  CaseWestern = 'https://case.edu/',
  UniversityOfCapeTown = 'https://www.uct.ac.za/',
  StudyAbroad = 'https://www.iesabroad.org/programs/cape-town-university-cape-town',
}

export enum Handle {
  LinkedIn = '@Jacob Alspaw',
  GitHub = '@jaa134',
  Facebook = '@jacobalexander.alspaw',
  Instagram = '@jacobalspaw',
  Twitter = '@JacobAlspaw',
}
